import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeDoorIdx: null,
  ref: null,
  hasExternalDoor: false,
  doors: [],
  location: {
    name: '',
    street: '',
  },
  size: null,
  phone: null,
  countryCode: null,
  statuses: [],
} as QiotState

const qiotSlice = createSlice({
  name: 'qiot',
  initialState,
  reducers: {
    setQiot: (state, action) => ({ ...state, ...action.payload }),
    resetQiot: (_, action) => ({ ...initialState, ...action.payload }),
    updateLockAllocation: (state, action) => {
      const { doorIdx, bookingId, phone, note } = action.payload
      const door = state.doors.find((d) => d.doorIdx === doorIdx)

      if (door?.allocation) {
        door.allocation.booking = bookingId ? { _id: bookingId, note, data: { client: { phone } } } : null
      }
    },
    updateBookingNote: (state, action) => {
      const { doorIdx, note } = action.payload
      const door = state.doors.find((d) => d.doorIdx === doorIdx)

      if (door?.allocation?.booking) {
        door.allocation.booking.note = note
      }
    },
  },
})

export const { setQiot, resetQiot, updateLockAllocation, updateBookingNote } = qiotSlice.actions

export default qiotSlice.reducer
